import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSidebarContext } from "../../scenes/global/sidebar/SidebarContext";

const TransactionDatePicker = ({ field, form }) => {
  const { theme } = useSidebarContext();
  const handleDateChange = (date) => {
    if (date && !isNaN(date.getTime())) {
      form.setFieldValue(field.name, date);
    } else {
      form.setFieldValue(field.name, null); // Clear the field if the date is invalid
    }
  };

  const handleManualInput = (e) => {
    const inputValue = e?.target?.value;

    if (inputValue) {
      // Parse manually entered date and validate
      const parsedDate = new Date(inputValue.split("/").reverse().join("/")); // Assuming DD/MM/YYYY format
      if (!isNaN(parsedDate.getTime())) {
        form.setFieldValue(field.name, parsedDate);
      } else {
        form.setFieldValue(field.name, null); // Clear if invalid
      }
    } else {
      form.setFieldValue(field.name, null); // Clear if input is empty or undefined
    }
  };

  return (
    <DatePicker
      selected={field.value ? new Date(field.value) : null}
      onChange={handleDateChange}
      onChangeRaw={handleManualInput}
      dateFormat="dd/MM/yyyy"
      className={`w-full px-4 py-3 ${theme.tailwind.bg46} backdrop-blur-sm border ${theme.tailwind.border2} rounded-xl focus:ring-2 ${theme.tailwind.focusRing1} ${theme.tailwind.focus4} text-gray-100 placeholder-gray-400 transition-all duration-300 shadow-lg ${theme.tailwind.shadow1}`}
      placeholderText="Select or type date...(DD/MM/YYYY)"
      wrapperClassName="w-full"
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      showPopperArrow={false}
      isClearable
      calendarClassName={`${theme.tailwind.bg14} border ${theme.tailwind.border19} rounded-lg shadow-lg`}
      dayClassName={(date) =>
        `text-gray-100 ${theme.tailwind.bgHover13} rounded-lg`
      }
      monthClassName={() => `text-gray-100`}
      weekDayClassName={() => `${theme.tailwind.text}`}
      todayButton="Today"
      todayButtonClassName={`${theme.tailwind.bg13} text-white rounded-lg px-4 py-2 mt-2 ${theme.tailwind.bgHover5} transition-colors duration-200`}
    />
  );
};

export default TransactionDatePicker;
